/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateCompositionsDetailMutationRequest, WebAppCreateCompositionsDetailMutationResponse, WebAppCreateCompositionsDetail401, WebAppCreateCompositionsDetail403 } from "../models/WebAppCreateCompositionsDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppCreateCompositionsDetail } from "../axios/webAppCreateCompositionsDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppCreateCompositionsDetailMutationKey = () => [{ url: '/web-app/v1/compositions' }] as const

export type WebAppCreateCompositionsDetailMutationKey = ReturnType<typeof webAppCreateCompositionsDetailMutationKey>

export function webAppCreateCompositionsDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WebAppCreateCompositionsDetailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = webAppCreateCompositionsDetailMutationKey()
        return mutationOptions<WebAppCreateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateCompositionsDetail401 | WebAppCreateCompositionsDetail403>, {data: WebAppCreateCompositionsDetailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return webAppCreateCompositionsDetail(data, config)
          },
        })

}

/**
 * @summary Create a composition
 * {@link /web-app/v1/compositions}
 */
export function useWebAppCreateCompositionsDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppCreateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateCompositionsDetail401 | WebAppCreateCompositionsDetail403>, {data: WebAppCreateCompositionsDetailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WebAppCreateCompositionsDetailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppCreateCompositionsDetailMutationKey()

          const baseOptions = webAppCreateCompositionsDetailMutationOptions(config) as UseMutationOptions<WebAppCreateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateCompositionsDetail401 | WebAppCreateCompositionsDetail403>, {data: WebAppCreateCompositionsDetailMutationRequest}, TContext>
          

          return useMutation<WebAppCreateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateCompositionsDetail401 | WebAppCreateCompositionsDetail403>, {data: WebAppCreateCompositionsDetailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppCreateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateCompositionsDetail401 | WebAppCreateCompositionsDetail403>, {data: WebAppCreateCompositionsDetailMutationRequest}, TContext>
      
}